import { Phone, MessageCircle, MoonStar } from "lucide-react";
import { BUSINESS, waLink } from "@/lib/site";
import { useLang } from "@/i18n";

export const MobileNav = () => {
    const { t } = useLang();
    const ITEMS = [
        { href: `tel:${BUSINESS.phoneTel}`, label: t("mobile.llamar"), icon: Phone, external: false, testid: "mobile-nav-llamar" },
        { href: waLink(t("wa.message")), label: t("mobile.mensaje"), icon: MessageCircle, external: true, testid: "mobile-nav-mensaje" },
        { href: waLink(t("wa.book")), label: t("mobile.reservar"), icon: MoonStar, external: true, testid: "mobile-nav-reservar" },
    ];

    return (
        <nav
            data-testid="mobile-bottom-nav"
            aria-label="Contacto rápido"
            className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-ink/90 backdrop-blur-xl border-t border-gold/20 pb-[env(safe-area-inset-bottom)]"
        >
            <div className="grid grid-cols-3">
                {ITEMS.map((item) => {
                    const Icon = item.icon;
                    return (
                        <a
                            key={item.testid}
                            href={item.href}
                            data-testid={item.testid}
                            {...(item.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                            className="flex flex-col items-center justify-center gap-1 py-2.5 text-cream/70 hover:text-gold active:text-gold transition-colors duration-300"
                        >
                            <Icon className="w-5 h-5" strokeWidth={1.6} />
                            <span className="font-accent text-[9px] tracking-[0.18em] uppercase">{item.label}</span>
                        </a>
                    );
                })}
            </div>
        </nav>
    );
};
